/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VcdsDeploymentSystemIssue } from './vcdsDeploymentSystemIssue';
import { VcdsDeploymentStats } from './vcdsDeploymentStats';


export interface VcdsDeploymentTail { 
    /**
     * Created by user
     */
    created_by?: string;
    /**
     * Deployment creation date time
     */
    created_time?: Date;
    /**
     * Deleted by user
     */
    deleted_by?: string;
    /**
     * Deployment deletion date time
     */
    deleted_time?: Date;
    /**
     * Last reported date time of inventory, usage or health from agent
     */
    last_reported_time?: Date;
    /**
     * Deployment last updated date time
     */
    last_updated_time?: Date;
    stats?: VcdsDeploymentStats;
    system_issues?: Array<VcdsDeploymentSystemIssue>;
    tasks?: Array<string>;
}

